<template>
  <CustomCreateDialog
    noCloseOnBackdrop
    dialogTitle="ایجاد مسابقه جدید"
    dialogId="create-match-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendCreateMatchRequest"
  >
    <BCol cols="12">
      <TextInput
        inputId="title"
        inputLabel="عنوان مسابقه"
        inputPlaceholder="مسابقه آیلتس..."
        v-model="matchPayload.title"
      ></TextInput>
    </BCol>
    <BCol cols="12" class="custom-picker-height">
      <MatchSettingPicker
        isInDialog
        @getMatchSetting="setMatchSetting"
      ></MatchSettingPicker>
    </BCol>
    <BCol cols="12" class="custom-picker-height">
      <QuestionPicker
        isInDialog
        :inputLabel="computedQuestionPickerLabel"
        :selectable="isQuestionsSelectable"
        @getQuestions="setQuestions"
      ></QuestionPicker>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      isLoading: false,
      tempSelectedMatchSetting: null,
      matchPayload: {
        title: null,
        matchSettingId: null,
        questionIds: [],
      },
    };
  },
  methods: {
    setMatchSetting(selectedMatchSetting) {
      this.tempSelectedMatchSetting = selectedMatchSetting;
      if (selectedMatchSetting) {
        this.matchPayload.matchSettingId = selectedMatchSetting.id;
      } else {
        this.matchPayload.matchSettingId = null;
      }
    },
    setQuestions(questions) {
      this.matchPayload.questionIds = questions.map(
        (question) => question.questionId
      );
    },
    async sendCreateMatchRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let createAMatch = new CreateAMatch(_this);
        createAMatch.setRequestParamDataObj(_this.matchPayload);
        await createAMatch.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "مسابقه با موفقیت ایجاد شد.",
              },
            });
            _this.matchPayload = {
              title: null,
              matchSettingId: null,
              questionIds: [],
            };
            this.$bvModal.hide("create-match-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    isQuestionsSelectable() {
      if (
        this.tempSelectedMatchSetting &&
        this.tempSelectedMatchSetting.totalMatchQuestionsCount &&
        this.matchPayload.questionIds.length <
          this.tempSelectedMatchSetting.totalMatchQuestionsCount
      ) {
        return true;
      }
      return false;
    },
  },
  computed: {
    computedQuestionPickerLabel() {
      return `سوال های مورد نظر را انتخاب کنید ${
        this.tempSelectedMatchSetting &&
        this.tempSelectedMatchSetting.totalMatchQuestionsCount
          ? `(${this.tempSelectedMatchSetting.totalMatchQuestionsCount} سوال)`
          : ""
      }`;
    },

    isOkButtonDisabled() {
      if (
        this.matchPayload.title &&
        this.matchPayload.matchSettingId &&
        this.matchPayload.questionIds.length &&
        !this.isLoading
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    CustomCreateDialog,
    MatchSettingPicker,
    QuestionPicker,
    TextInput,
    BCol,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import MatchSettingPicker from "@/views/components/Matches/MatchSettingPicker.vue";
import QuestionPicker from "@/views/components/Questions/QuestionPicker.vue";
import { CreateAMatch } from "@/libs/Api/Matches";
import { BCol } from "bootstrap-vue";
</script>
<style scoped></style>
